import * as React from "react";
import PropTypes from "prop-types";

const PreviewTable = ({ suggestedColors, suggestedHeaderFont, suggestedBodyFont }) => {
  const colors = Object.groupBy(suggestedColors, (c) => c.name);
  function getColor(name) {
    const c = colors[name][0];
    return c.newValue ?? c.value;
  }

  return colors && colors["accent1"] && colors["accent1"][0] ? (
    <div
      style={{
        background: getColor("background"),
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridTemplateRows: "auto auto",
          border: "1px solid " + getColor("accent1"),
          padding: 4,
          gap: 2,
          background: getColor("background"),
        }}
      >
        <div
          style={{
            fontFamily: suggestedHeaderFont,
            fontSize: 14,
            alignContent: "center",
            textAlign: "center",
            padding: "4px 8px",
            background: getColor("accent1"),
            color: getColor("text2"),
          }}
        >
          Header
        </div>
        <div
          style={{
            fontFamily: suggestedHeaderFont,
            fontSize: 14,
            alignContent: "center",
            textAlign: "center",
            padding: "4px 8px",
            background: getColor("accent2"),
            color: getColor("text2"),
          }}
        >
          Header
        </div>
        <div
          style={{
            fontFamily: suggestedHeaderFont,
            fontSize: 14,
            alignContent: "center",
            textAlign: "center",
            padding: "4px 8px",
            background: getColor("shading2"),
          }}
        >
          Header
        </div>
        <div
          style={{
            fontFamily: suggestedBodyFont,
            fontSize: 10,
            alignContent: "center",
            textAlign: "center",
            aspectRatio: 1,
            background: getColor("secondary1"),
          }}
        >
          Body
        </div>
        <div
          style={{
            fontFamily: suggestedBodyFont,
            fontSize: 10,
            alignContent: "center",
            textAlign: "center",
            aspectRatio: 1,
            background: getColor("secondary2"),
          }}
        >
          Body
        </div>
        <div
          style={{
            fontFamily: suggestedBodyFont,
            fontSize: 10,
            alignContent: "center",
            textAlign: "center",
            aspectRatio: 1,
            background: getColor("shading1"),
          }}
        >
          Body
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

PreviewTable.propTypes = {
  suggestedColors: PropTypes.array.isRequired,
  suggestedHeaderFont: PropTypes.string.isRequired,
  suggestedBodyFont: PropTypes.string.isRequired,
};

export default PreviewTable;
